import { ComponentType, lazy } from 'react';
import { deferImport } from 'utils/helper';

/* For route that need to be used on multiple path without re-render */
/* We will need to create an unique instance of that component here */
/* This is for react-router-dom to be able to regconize */
const SDSAuthoringPage = lazy((): Promise<any> => {
  return deferImport(import('pages/sds-authoring'));
});

export interface RouteInterface {
  path: string;
  key?: string;
  exact: boolean;
  active: boolean;
  RouteComponent: ComponentType<any>;
  props?: { [name: string]: any };
}

export const guardRoutes: Array<RouteInterface> = [
  {
    path: '/account/security',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/account/security'));
    }),
    active: true,
  },
  {
    path: '/sds-authoring',
    exact: true,
    RouteComponent: SDSAuthoringPage,
    active: true,
  },
  {
    path: '/sds-authoring/:sdsId',
    exact: true,
    RouteComponent: SDSAuthoringPage,
    active: true,
  },
  {
    path: '/our-components',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/our-components'));
    }),
    active: true,
  },
  {
    path: '/supplier-manufacturer',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/supplier-manufacturer'));
    }),
    active: true,
  },
  {
    path: '/our-components/:id',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/component-structured-data'));
    }),
    active: true,
  },
];

export const defaultRoutes: Array<RouteInterface> = [
  {
    path: '/',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/our-sds'));
    }),
    active: true,
  },
  {
    path: '/onesignin/:userId/:token',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/one-signin'));
    }),
    active: true,
  },
  {
    path: '/reset-password',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/reset-password'));
    }),
    active: true,
  },
  {
    path: '/reset-password/:userId/:token',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(
        import('pages/reset-password/ResetPasswrodSetPassword')
      );
    }),
    active: true,
  },
  {
    path: '/login',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/login'));
    }),
    active: true,
  },
  {
    path: '/pdf/:id',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(
        import('pages/pdf-download-viewer-page/PDFDownloadViewerPage')
      );
    }),
    active: true,
  },
  {
    path: '/public-view/:token',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(
        import('pages/original-sds-viewer/OriginalSDSViewerPage')
      );
    }),
    active: true,
  },
  {
    path: '/permissions-denied',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(
        import('pages/permissions-denied/PermissionsDeniedPage')
      );
    }),
    active: true,
  },
  {
    path: '/external-login',
    exact: true,
    RouteComponent: lazy((): Promise<any> => {
      return deferImport(import('pages/external-login/ExternalLoginPage'));
    }),
    active: true,
  },
];
